import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import MetaTags from '../components/common/MetaTags';
import BlogList from '../components/Blog/BlogList';
import MainTitle from '../components/common/MainTitle';

import scrollToTarget from '../js/utils/scroll';

export default function BlogPage() {
  const { t } = useTranslation(['BlogPage']);

  useEffect(() => {
    const element = document?.getElementById('blog-page');
    scrollToTarget(element);
  }, []);

  return (
    <main className="blog-page" id="blog-page">
      <MetaTags title={t('pageTitle')} />
      <section className="blog-page__hero container">
        <MainTitle type="dark" className="text--2xl">
          <span>{t('title1')}</span>
          <span className="decorated-line decorated-line--dark decorated-line--left">
            {t('title2')}
          </span>
        </MainTitle>
        <p className="blog-page__subtitle">{t('subtitle')}</p>
      </section>
      <BlogList />
    </main>
  );
}
